module.exports = __webpack_public_path__ + "static/media/logo_gol.e275ca12.png";